import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, isValidElement, useState, useEffect, } from 'react';
import 'framer-motion';
import { PLACEMENT } from '../../values/Placement';
export const PLACEMENT_MAP = {
    AUTO: PLACEMENT.AUTO,
    TOP: PLACEMENT.TOP,
    RIGHT: PLACEMENT.RIGHT,
    BOTTOM: PLACEMENT.BOTTOM,
    LEFT: PLACEMENT.LEFT,
};
const PopoverTitle = ({ className = '', children }) => (_jsx("div", Object.assign({ className: `popover-header popover-title ${className}` }, { children: children })));
const PopoverContent = ({ className = '', children }) => (_jsx("div", Object.assign({ className: `popover-content popover-body ${className}` }, { children: children })));
const isPopoverTitleOrContent = (element) => {
    return isValidElement(element) && (element.type === PopoverTitle || element.type === PopoverContent);
};
const Popover = forwardRef((props, ref) => {
    const { placement = 'bottom', arrowProps, title, titleClassName = '', contentClassName = '', children, className = '' } = props, remainingProps = __rest(props, ["placement", "arrowProps", "title", "titleClassName", "contentClassName", "children", "className"]);
    const hasTitle = !!title;
    const hasCustomContent = React.Children.toArray(children).some(isPopoverTitleOrContent);
    // Mount the component but don't show it yet via CSS.
    // After it is mounted, we set the visibility class to use CSS animation
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => setIsMounted(true), []);
    return (_jsxs("div", Object.assign({}, remainingProps, { role: 'tooltip', "x-placement": placement, ref: ref, className: `popover fade ${isMounted ? 'show' : ''} ${className}` }, { children: [_jsx("div", Object.assign({ className: 'arrow' }, arrowProps)), hasTitle && _jsx(PopoverTitle, Object.assign({ className: titleClassName }, { children: title })), hasCustomContent ? children : _jsx(PopoverContent, Object.assign({ className: contentClassName }, { children: children }))] })));
});
Popover.Title = PopoverTitle;
Popover.Content = PopoverContent;
Object.assign(Popover, PLACEMENT_MAP);
export default Popover;
